import { Button, ButtonProps } from '@lounge-fe/ui-kit/src/components/Button'

const CallToAction = (props: ButtonProps & { href: string }) =>
  props.children ? <Button as="a" variant="outline" {...props} /> : null

export default CallToAction
